import { render, staticRenderFns } from "./CatalogsRecivier.vue?vue&type=template&id=a4b4d668&scoped=true&"
import script from "./CatalogsRecivier.vue?vue&type=script&lang=js&"
export * from "./CatalogsRecivier.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsRecivier.vue?vue&type=style&index=0&id=a4b4d668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b4d668",
  null
  
)

export default component.exports
import {QItem,QItemSection,QInput,QItemLabel,QScrollArea,QTree,QIcon,QRadio} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QInput,QItemLabel,QScrollArea,QTree,QIcon,QRadio}, component.options.components || {})
